import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FooterRedesign.css';

function FooterRedesign() {
  var navigate = useNavigate();

  return (
    <footer className="footer-redesign">
      <div className="footer-redesign__inner">
        <p className="footer-redesign__disclaimer">
          Easy Global Entry is not affiliated with, endorsed by, or sponsored by U.S. Customs and Border Protection or the U.S. Government.
        </p>
        <div className="footer-redesign__links">
          <a className="footer-redesign__link" href="/privacy" onClick={function(e) { e.preventDefault(); navigate('/privacy'); window.scrollTo(0, 0); }}>Privacy</a>
          <a className="footer-redesign__link" href="/contact" onClick={function(e) { e.preventDefault(); navigate('/contact'); window.scrollTo(0, 0); }}>Contact</a>
          <a className="footer-redesign__link" href="/blog" onClick={function(e) { e.preventDefault(); navigate('/blog'); window.scrollTo(0, 0); }}>Blog</a>
          <a className="footer-redesign__link" href="mailto:support@easyglobalentry.com">Support</a>
        </div>
      </div>
    </footer>
  );
}

export default FooterRedesign;
